import { render, staticRenderFns } from "./learnDefault.vue?vue&type=template&id=9e0a4546&scoped=true&"
import script from "./learnDefault.vue?vue&type=script&lang=js&"
export * from "./learnDefault.vue?vue&type=script&lang=js&"
import style0 from "./learnDefault.vue?vue&type=style&index=0&id=9e0a4546&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0a4546",
  null
  
)

export default component.exports